import ClientStrip from "./ClientStrip";

export default ClientStrip;